import { render, staticRenderFns } from "./CifsList.vue?vue&type=template&id=0fb5f339"
import script from "./CifsList.vue?vue&type=script&lang=js"
export * from "./CifsList.vue?vue&type=script&lang=js"
import style0 from "./CifsList.vue?vue&type=style&index=0&id=0fb5f339&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports